import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import * as moment from 'moment';

import {
  TableSettings,
  TableModeEnum,
  FieldMapItem,
  NotificationService,
} from 'beyond-util';

import { BackendService } from '../../../services/backend.service';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { MontazaService } from '../../../services/montaza.service';
import { MONTAZA_PROVERI } from '../../../constants/tooltip-messages';

@Component({
  selector: 'app-pregled-dana-details',
  templateUrl: './pregled-dana-details.component.html',
})
export class PregledDanaDetailsComponent implements OnInit, OnDestroy {
  @Input() programFieldSettings: FieldMapItem;
  @Input() emisijaFieldSettings: FieldMapItem;
  @Input() datumFieldSettings: FieldMapItem;
  @Input() selectedProgram: any;
  @Input() selectedDatum: any;

  private _subscriptions: Subscription[] = [];

  public TableModeEnum = TableModeEnum;
  public moment = moment;

  public spotoviSettingsTable: TableSettings;
  public spotovi: any[] = [];
  public filterQuery: string;

  public showDetails = false;
  public vremeProvere: any;
  public currentText: string;

  public tooltipOptions = {
    placement: 'top',
    'show-delay': '500',
    theme: 'light',
  };

  public tooltips = {
    MONTAZA_PROVERI,
  };

  constructor(
    private _rtsBackendService: BackendService,
    private _notificationService: NotificationService,
    private _montazaService: MontazaService
  ) {}

  ngOnInit() {
    this.subscribeToMontazaData();
    this.subscribeToPremestiEmisiju();
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  subscribeToMontazaData() {
    this._subscriptions.push(
      this._montazaService.montazaData$.subscribe(() => {
        this.showDetails = true;
        this.fetchSpotoviSettings();
      })
    );
  }

  subscribeToPremestiEmisiju() {
    this._subscriptions.push(
      this._montazaService.premestiEmisiju$.subscribe(() => {
        this.resetForm();
      })
    );
  }

  removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }

  resetForm() {
    this.spotovi = [];
    this.vremeProvere = null;
  }

  fetchSpotoviSettings() {
    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMON_PDA,
      FormName.Montaza,
      EndpointTypes.GetAllEntities,
      `?montazaId=${this._montazaService.montaza.Id}`
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          const numField = response.Settings.allFields.find(
            field => field.name === 'Rbr'
          );
          if (numField) {
            numField.width = 1;
            numField.sortable = false;
          }

          this.spotoviSettingsTable = new TableSettings(
            response.Settings,
            'table'
          );

          const data = response.ServiceData;
          let count = 1;
          data.forEach(d => {
            d.Rbr = count++;
            d.TrajanjeSekunde = d.SpotTrajanje;
            d.Naziv = d.SpotNaziv;
            d.Sifra = d.SpotSifra;
            d.JePrisutanNaVideoServeru = d.JePrisutanNaVideoServeru;
            d.VremeTrajanjaServer = d.VremeTrajanjaServer;
          });

          this.spotovi = data;
        })
    );
  }

  osveziStanje() {
    this.vremeProvere = moment().format('DD.MM.YYYY. HH:mm:ss');
  }

  proveri() {
    const entity = {
      Spotovi: this.spotovi,
      MontazaId: this._montazaService.montaza.Id,
    };

    const payload = this._rtsBackendService.getRequestPayload(
      FormCode.MSMON_PDCVS,
      FormName.Montaza,
      EndpointTypes.PostEntity,
      null,
      entity,
      null
    );

    this._subscriptions.push(
      this._rtsBackendService
        .fetchMediaPlanSettings(payload)
        .subscribe((response: any) => {
          if (this._montazaService.hasError(response)) {
            this._notificationService.notyError(
              response['Errors'][0]['ErrorMessage']
            );

            return;
          }

          if (!Array.isArray(response.ServiceData)) {
            this._notificationService.notyError(
              'Desila se greška prilikom provere sa servera.'
            );

            return;
          }

          const data = response.ServiceData;
          data.forEach(d => {
            d.SadrzajId = d.Id;
            d.TrajanjeSekunde = d.TrajanjeSekunde;
            d.Naziv = d.Naziv;
            d.Sifra = d.Sifra;
            d.JePrisutanNaVideoServeru = d.JePrisutanNaVideoServeru;
            d.VremeTrajanjaServer = d.VremeTrajanjaServer;
          });

          this.spotovi = this.removeDuplicates(data, 'SpotId');
          this.osveziStanje();
        })
    );
  }

  // Nisam siguran zasto ide ovaj korak?
  getVremeTrajanjaServer(noviSpot: any) {
    const spot = this.spotovi.find(s => s.SadrzajId === noviSpot.Id);

    return spot ? spot.VremeTrajanjaServer : null;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/montaza/pregled-dana-details/pregled-dana-details.component.ts